import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class EiaChartsService {

  baseUrl: string;

  constructor(public http: HttpClient) { }

}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/eia-charts.service.ts